import React, { useState, useRef, useEffect } from "react";
import "./VideoGallery.css";
import { REACT_APP_API_URL } from "../env";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const VideoGallery = () => {
  const [videos, setVideos] = useState([]);
  const [activeVideo, setActiveVideo] = useState(null);
  const [popupVideo, setPopupVideo] = useState(null);

  const videoRefs = useRef({});
  const activeVideoRef = useRef(null);
  const popupVideoRef = useRef(null);
  const navigate = useNavigate();

  const buildUrl = (pathOrLink, mode) => {
    if (!pathOrLink) return null;
    if (mode === "file") {
      const cleanPath = pathOrLink.startsWith("/") ? pathOrLink : `/${pathOrLink}`;
      return `${REACT_APP_API_URL}${cleanPath}`;
    }
    return pathOrLink;
  };

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await axios.get(
          `${REACT_APP_API_URL}/api/dashboard/admin/list-all-videos?mode=gallery`
        );
        const data = res.data.data || [];

        const sorted = data.sort(
          (a, b) => new Date(b.dtmCreatedOn) - new Date(a.dtmCreatedOn)
        );

        const galleryVideos = sorted
          .map((v) => {
            const url1 =
              v.vchVideo1Mode === "file"
                ? buildUrl(v.vchVideo1DesktopPath, "file")
                : v.vchVideo1DesktopLink;

            const url2 =
              v.vchVideo2Mode === "file"
                ? buildUrl(v.vchVideo2DesktopPath, "file")
                : v.vchVideo2DesktopLink;

            return {
              id: v.intVideoID,
              url: url1 || url2,
              title: v.vchLabel || `Video ${v.intVideoID}`,
              created: v.dtmCreatedOn,
            };
          })
          .filter((v) => v.url);

        const topFour = galleryVideos.slice(0, 4);
        setVideos(topFour);
        if (topFour.length) setActiveVideo(topFour[0]);
      } catch (error) {
        console.error("Failed to fetch videos:", error);
      }
    };

    fetchVideos();
  }, []);

  const pauseAllVideos = () => {
    Object.values(videoRefs.current).forEach((v) => v && v.pause());
    if (activeVideoRef.current) activeVideoRef.current.pause();
    if (popupVideoRef.current) popupVideoRef.current.pause();
  };

  const handleVideoClick = (video) => {
    if (!popupVideo) {
      pauseAllVideos();
      setActiveVideo(video);
    }
  };

  const handlePopupOpen = (video) => {
    pauseAllVideos();
    setPopupVideo(video);
  };

  const handlePopupClose = () => {
    if (popupVideoRef.current) popupVideoRef.current.pause();
    setPopupVideo(null);
  };

  return (
    <div className="Video-gallery-main">
      <h2 className="video-gallery-title">Experience in Motion</h2>

      <div className="video-gallery">
        <div className="active-video">
          {activeVideo ? (
            <video
              key={activeVideo.url}
              className="active-video-player"
              src={activeVideo.url}
              controls
              onClick={() => handlePopupOpen(activeVideo)}
              ref={(el) => {
                activeVideoRef.current = el;
                if (el) videoRefs.current[`active-${activeVideo.id}`] = el;
              }}
              onPlay={(e) => {
                if (popupVideo) e.target.pause();
              }}
            />
          ) : (
            <p>No videos available</p>
          )}
        </div>
        <div className="video-sidebar">
          {videos.map((video) => (
            <div
              key={`thumb-${video.id}`}
              className={`video-thumbnail ${video.id === activeVideo?.id ? "active" : ""
                }`}
              onClick={() => handleVideoClick(video)}
            >
              <video
                src={video.url}
                muted
                loop
                onMouseEnter={(e) => !popupVideo && e.target.play()}
                onMouseLeave={(e) => !popupVideo && e.target.pause()}
                ref={(el) => (videoRefs.current[`thumb-${video.id}`] = el)}
              />
              <p className="video-title">{video.title}</p>
            </div>
          ))}

          <button
            className="view-all-btn"
            onClick={() => navigate("/all-videos")}
          >
            View More ➜
          </button>
        </div>
        {popupVideo && (
          <div className="popup-overlay" onClick={handlePopupClose}>
            <div className="popup-video" onClick={(e) => e.stopPropagation()}>
              <video
                className="popup-video-player"
                src={popupVideo.url}
                controls
                autoPlay
                ref={popupVideoRef}
              />
              <button className="close-popup" onClick={handlePopupClose}>
                ×
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoGallery;
